import { Component, Input, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SocialAiReachChartComponent } from "../social-ai-reach-chart/social-ai-reach-chart.component";
import { SocialAiImpressionsChartComponent } from "../social-ai-impressions-chart/social-ai-impressions-chart.component";
import { SocialAiEngagementChartComponent } from "../social-ai-engagement-chart/social-ai-engagement-chart.component";

@Component({
  selector: "app-social-ai-trends-chart",
  standalone: true,
  imports: [
    CommonModule,
    SocialAiReachChartComponent,
    SocialAiImpressionsChartComponent,
    SocialAiEngagementChartComponent,
  ],
  templateUrl: "./social-ai-trends-chart.component.html",
  styleUrls: ["./social-ai-trends-chart.component.scss"],
})
export class SocialAiTrendsChartComponent  {
  @Input() selectedSiteId: number | null = null;
  @Input() selectedPlatformId: number | null = null;
  @Input() selectedPeriod!: string;
  @Input() pages: any[] = [];

  @ViewChild(SocialAiReachChartComponent)
  reachChart?: SocialAiReachChartComponent;

  activeTab: string = "reach"; 
  tabs = [
    { key: "reach", label: "Reach" },
    { key: "impressions", label: "Impressions" },
    { key: "engagement", label: "Engagement Rate" },
  ];

  isReachLoaded = false;
  isImpressionsLoaded = false;
  isEngagementLoaded = false;

  get isInstagram(): boolean {
  const platform = this.pages?.[0]?.platform?.toLowerCase() || "";
  return platform.includes("instagram");
}

 ngOnChanges() {
    if (this.isInstagram) {
      this.activeTab = 'reach';
    }
  }

  setActiveTab(tabKey: string) {
    this.activeTab = tabKey;

    if (tabKey === "reach" && !this.isReachLoaded && this.reachChart) {
      this.reachChart.loadReachData();
      this.isReachLoaded = true;
    }
    if (tabKey === "impressions") this.isImpressionsLoaded = true;
    if (tabKey === "engagement") this.isEngagementLoaded = true;
  }
}
